export default (passes, message) => {
  return {
    passes,
    message,
  };
};
